import React from 'react';
import { SnackbarProvider, ThemeProvider } from '@uala/ui';
import { QueryClientProvider } from 'react-query';
import queryClient from './config/queryClient';
import GlobalStyles from './utils/globalStyles';
import styled from 'styled-components';
import UserDataProvider from './features/contexts/userContext';
import { Amplify } from 'aws-amplify';
import AmplifyConfig from './amplify.config';
import Split from './components/Split';
import AmplitudeProvider from './features/contexts/AmplitudeProvider';
import { AbraProvider } from '@uala/abra';
import Routes from './Routes';

Amplify.configure(AmplifyConfig);

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AbraProvider>
        <SnackbarProvider>
          <UserDataProvider>
            <QueryClientProvider client={queryClient}>
              <GlobalStyles />
              <Container>
                <Split>
                  <AmplitudeProvider>
                    <Routes />
                  </AmplitudeProvider>
                </Split>
              </Container>
            </QueryClientProvider>
          </UserDataProvider>
        </SnackbarProvider>
      </AbraProvider>
    </ThemeProvider>
  );
};

export default App;

const Container = styled.section`
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  min-height: 100vh;

  @media (max-width: 480px) {
    box-sizing: border-box;
    padding: 0;
  }
`;
